<template>
    <div class="mingtang hml_whplt">
        <swiperList :swiperStyle="{padding: '2.7rem .4rem .5rem'}">
            <li
            class="mingtangSilde"
            v-for="(item,index) in list"
            :key="index"
            @click="sildeClick(item)"
            >
                <div class="textBox">
                    <h2 class="title">{{ item.title }}</h2>
                    <p>{{ item.description }}</p>
                    <img src="@/assets/img/secondLevelPage/mingdianXian.png" alt="" class="mingdianXian">
                </div>
                <div class="img">
                    <img :src="item.thumb">
                </div>
            </li>
        </swiperList>
    </div>
</template>

<script>

export default {
    data() { 
        return {
        }
    },
    created(){
        this.list.sort((a,b) => {
            return a.food_id - b.food_id;
        })
    },
    methods: {
        sildeClick(item){
            this.$emit("sildeClick",item,1)
        }
    },
    props: {
        list: {
            type: Array
        }
    }
}
</script>

<style lang="scss" scoped>
.mingtang{
    padding-top: 2.25rem;
    .mingtangSilde{
        width: 6.7rem;
        height: 2.3rem;
        box-shadow:0px .04rem .1rem 0px rgba(41,41,41,0.2);
        border-radius: .1rem;
        margin-bottom: .32rem;
        background: #fff;
        position: relative;
        padding-right: .4rem;
        margin-bottom: .80rem;
        .img{
            width: 3rem;
            height: 2rem;
            border-radius: .1rem;
            overflow: hidden;
            position: absolute;
            right: .4rem;
            top: -.32rem;
            box-shadow: .1rem .14rem .28rem 0px rgba(0, 0, 0, 0.24);
            img{
                // width: 3rem;
                // height: 1.92rem;
                height: 100%;
            }
        }
        .textBox{
            height: 100%;
            padding-top: .24rem;
            position: absolute;
            left: 0;
            top: .24rem;
            .title{
                color: #fff;
                font-family: "siyuan";
                font-weight: bold;
                background:linear-gradient(0deg,rgba(65,192,162,1) 0%,rgba(15,164,130,1) 100%);
                font-size: .32rem;
                padding: .16rem .26rem .2rem .2rem;
                border-radius: 0px .04rem .5rem 0px;
            }
            p{
                font-size: .24rem;
                color: #666;
                margin-top: .18rem;
                padding-left: .22rem;
            }
            img{
                width: 5.56rem;
                height: .38rem;
                position: absolute;
                left: 0;
                bottom: .62rem;
            }
        }
    }
}
</style>